import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, Transition as _Transition, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3bdc92ca")

_pushScopeId("data-v-3bdc92ca")
const _hoisted_1 = {
  class: "flex flex-row items-center justify-between mt-4 px-7 pb-2",
  style: {"border-bottom":"1px solid rgba(224, 224, 224, 1)"}
}
const _hoisted_2 = { class: "text-xl text-black-lp-300 font-semibold" }
const _hoisted_3 = { class: "flex flex-row items-center gap-4" }
const _hoisted_4 = {
  class: "flex flex-col gap-2.5",
  style: {"padding-bottom":"10px"}
}
const _hoisted_5 = {
  key: 0,
  class: "p-field-checkbox relative mt-2"
}
const _hoisted_6 = { class: "flex flex-row items-center gap-5" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "text-base font-semibold text_checkbox_all_list_kulioner " }, " Pilih semua ", -1)
const _hoisted_8 = {
  key: 1,
  class: "w-full translate-y-2/3",
  style: {"transform":"translateY(30%)"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DropdownSearch = _resolveComponent("DropdownSearch")!
  const _component_DownloadReports = _resolveComponent("DownloadReports")!
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!
  const _component_TabFilter = _resolveComponent("TabFilter")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_CardListKulioner = _resolveComponent("CardListKulioner")!
  const _component_VirtualScroll = _resolveComponent("VirtualScroll")!
  const _component_PaginationV3 = _resolveComponent("PaginationV3")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_FooterListKulioner = _resolveComponent("FooterListKulioner")!
  const _component_WidgetDownload = _resolveComponent("WidgetDownload")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("kulioner.customer.title")), 1),
      _createVNode("section", _hoisted_3, [
        _createVNode(_component_DropdownSearch, {
          id: "dropdown_search_list_kulioner",
          class: "self-end",
          searchByOptions: _ctx.searchByOptions,
          defaultSearchBy: _ctx.$t('kulioner.customer.searchBy.orderId'),
          placeholderSearch: _ctx.$t('Cari'),
          modelValue: _ctx.filter.searchValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.searchValue = $event)),
          searchBy: _ctx.filter.searchBy,
          "onUpdate:searchBy": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.searchBy = $event)),
          onSearch: _ctx.onSearch,
          onSearchBy: _ctx.onSearchBy
        }, null, 8, ["searchByOptions", "defaultSearchBy", "placeholderSearch", "modelValue", "searchBy", "onSearch", "onSearchBy"]),
        _createVNode(_component_DownloadReports),
        _createVNode(_component_TimeRangePicker, {
          class: "mr-4 kulioner-calendar",
          isCloseDateAfterSelect: "",
          default: _ctx.$t('30 hari terakhir'),
          highlightOnSelected: true,
          customCalendar: true,
          advanceStyle: {
          width: '550px',
          fontSize: 'text-sm',
          fontWeight: 'font-medium'
        },
          customTotalMaxDate: 30,
          resetLimitOnSetOption: "",
          isDateAlignCenter: "",
          maxDate: new Date(),
          isSetMaxDate: "",
          startDate: _ctx.filter.dateRange.start,
          endDate: _ctx.filter.dateRange.end,
          customDefaultValue: "",
          labelCustom: "Rentang tanggal",
          showOptions: 
          `${_ctx.$t('custom')}, ${_ctx.$t('7 hari terakhir')}, ${_ctx.$t(
            '14 hari terakhir'
          )}, ${_ctx.$t('30 hari terakhir')}`
        ,
          isConvertName: "",
          isMounted: false,
          onSelect: _ctx.setPeriod
        }, null, 8, ["default", "maxDate", "startDate", "endDate", "showOptions", "onSelect"])
      ])
    ]),
    _createVNode("div", {
      class: ["px-6 py-4 bg-gray-lp-1000 overflow-auto flex flex-col", [{'h-full': !!_ctx.listKulioner.data.orders.length || _ctx.errorState}]]
    }, [
      _createVNode("section", _hoisted_4, [
        _createVNode(_component_TabFilter, {
          summary: _ctx.listSummaryStatus,
          modelValue: _ctx.currentTab,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentTab = $event)),
          onChange: _ctx.changeTab
        }, null, 8, ["summary", "modelValue", "onChange"]),
        _createVNode("div", {
          class: ["flex flex-row items-center w-full", [
          {'justify-between': _ctx.isShowCheckAll},
          {'justify-end': !_ctx.isShowCheckAll},
        ]]
        }, [
          (_ctx.isShowCheckAll)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_Checkbox, {
                    id: "checkbox_select_all_list_kulioner",
                    binary: true,
                    modelValue: _ctx.isCheckedAll,
                    onChange: _ctx.onCheckAll
                  }, null, 8, ["modelValue", "onChange"]),
                  _hoisted_7
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      (!_ctx.errorState)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            id: "kulioner-list-content-parent",
            class: ["overflow-auto pb-16 flex-grow", [
        {
          'h-screen' : _ctx.isLoadingFetchList,
          'overflow-hidden':  _ctx.isLoadingFetchList
        }
      ]],
            onScrollPassive: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onScrollListParent && _ctx.onScrollListParent(...args)))
          }, [
            _withDirectives(_createVNode(_component_VirtualScroll, {
              ref: "virtualScroll",
              parentId: "kulioner-list-content-parent",
              dataList: _ctx.listKulioner.data.orders,
              enableVirtualScroll: "",
              itemHeight: 311
            }, {
              default: _withId(({item}) => [
                _createVNode(_component_CardListKulioner, {
                  data: item,
                  isCheckable: _ctx.isShowCheckAll,
                  isChecked: !!_ctx.checkedData.find(ckData => ckData.id === item.id),
                  onCheck: _ctx.handleCheck,
                  onUncheck: _ctx.handleUnCheck,
                  onSuccessProcessOrder: _ctx.getListKulioner
                }, null, 8, ["data", "isCheckable", "isChecked", "onCheck", "onUncheck", "onSuccessProcessOrder"])
              ]),
              _: 1
            }, 8, ["dataList"]), [
              [_vShow, !_ctx.isLoadingFetchList]
            ]),
            (_ctx.listKulioner.data.orders.length)
              ? (_openBlock(), _createBlock(_component_PaginationV3, {
                  key: 0,
                  class: "px-4 rounded-xl",
                  pagination: _ctx.listKulioner.pagination,
                  "onUpdate:pagination": _cache[4] || (_cache[4] = ($event: any) => (_ctx.listKulioner.pagination = $event)),
                  onSetPage: _ctx.toPage,
                  renderedData: _ctx.listKulioner.data.orders.length,
                  paginationWidth: "w-full",
                  paginationV3PaddingVertical: "pb-4 pt-5"
                }, null, 8, ["pagination", "onSetPage", "renderedData"]))
              : _createCommentVNode("", true)
          ], 34))
        : _createCommentVNode("", true),
      (_ctx.errorState)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            (_ctx.errorState === 'empty')
              ? (_openBlock(), _createBlock(_component_EmptyState, {
                  key: 0,
                  customClass: "error-class",
                  customHeaderMessage: _ctx.$t('kulioner.customer.emptyHeader'),
                  customMessage: _ctx.$t('kulioner.customer.emptyMessage')
                }, null, 8, ["customHeaderMessage", "customMessage"]))
              : _createCommentVNode("", true),
            (_ctx.errorState === _ctx.CLIENT_ERROR || _ctx.errorState === _ctx.INTERNAL_SERVER_ERROR)
              ? (_openBlock(), _createBlock(_component_EmptyState, {
                  key: 1,
                  customClass: "error-class",
                  customHeaderMessage: _ctx.$t('kulioner.customer.systemErrorHeader'),
                  customMessage: _ctx.$t('kulioner.customer.systemErrorMessage'),
                  icon: "error-token-ngen",
                  buttonAction: {
          title: _ctx.$t('kulioner.customer.reload'),
          textColor: 'white',
          fontWeight: 'semibold',
          iconLeft: 'reload-white',
          sizeIcon: '12px'
        },
                  onAction: _ctx.getListKulioner
                }, null, 8, ["customHeaderMessage", "customMessage", "buttonAction", "onAction"]))
              : _createCommentVNode("", true),
            (_ctx.errorState === _ctx.SPECIAL_ERROR)
              ? (_openBlock(), _createBlock(_component_EmptyState, {
                  key: 2,
                  icon: "ill_spot_search",
                  customClass: "error-class",
                  customHeaderMessage: _ctx.$t('kulioner.customer.searchNotFoundHeader'),
                  customMessage: _ctx.$t('kulioner.customer.searchNotFoundMessage')
                }, null, 8, ["customHeaderMessage", "customMessage"]))
              : _createCommentVNode("", true),
            (_ctx.errorState === _ctx.INTERNET_ERROR)
              ? (_openBlock(), _createBlock(_component_EmptyState, {
                  key: 3,
                  icon: "error-internet",
                  customClass: "error-class",
                  customHeaderMessage: _ctx.$t('kulioner.customer.internetErrorHeader'),
                  customMessage: _ctx.$t('kulioner.customer.internetErrorMessage'),
                  buttonAction: {
          title: _ctx.$t('kulioner.customer.reload'),
          textColor: 'white',
          fontWeight: 'semibold',
          iconLeft: 'reload-white',
          sizeIcon: '12px'
        },
                  onAction: _ctx.getListKulioner
                }, null, 8, ["customHeaderMessage", "customMessage", "buttonAction", "onAction"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_Transition, { name: "kulioner-footer" }, {
      default: _withId(() => [
        (_ctx.checkedData.length)
          ? (_openBlock(), _createBlock(_component_FooterListKulioner, {
              key: 0,
              selected: _ctx.checkedData,
              status: _ctx.currentTab,
              onRefetch: _ctx.getListKulioner,
              onOnSuccesOrder: _ctx.onSuccessBulkOrder
            }, null, 8, ["selected", "status", "onRefetch", "onOnSuccesOrder"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_WidgetDownload, {
      style: `${_ctx.checkedData.length ? 'bottom: 56px;' : ''}`,
      customTitle: "Download data"
    }, null, 8, ["style"]),
    _createVNode(_component_Loading, { modelValue: _ctx.isShowLoadingFetchListModal }, null, 8, ["modelValue"])
  ], 64))
})